import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginwebappComponent } from './loginwebapp/loginwebapp.component';

const routes: Routes = [
  {
    path: '',
    component: LoginwebappComponent,
    children: [
      {
        path: 'loginwebapp',
        loadChildren: () => import('./loginwebapp/loginwebapp.module').then(m => m.LoginwebappModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
